export const SET_USER_ROLE = 'setUserRole';
export const INIT_USER_ROLE = 'initUserRole';
export const FETCH_USER = 'fetchUser';
export const LOGOUT = 'logout';
